// extracted by mini-css-extract-plugin
export var floatRight = "label-list-module--floatRight--3de92";
export var labelList = "label-list-module--labelList--77166";
export var small = "label-list-module--small--f1048";
export var textList = "label-list-module--textList--67152";
export var withBackground = "label-list-module--withBackground--74b4d";